import { render, staticRenderFns } from "./MembershipDetailsModal.vue?vue&type=template&id=2bd75436&scoped=true"
import script from "./MembershipDetailsModal.vue?vue&type=script&lang=js"
export * from "./MembershipDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./MembershipDetailsModal.vue?vue&type=style&index=0&id=2bd75436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd75436",
  null
  
)

export default component.exports